export const translations = {
  codigoSap: {
    pt: 'Código ERP',
    en: 'ERP Code',
    es: 'Código ERP',
    de: 'ERP-Code',
  },
  codigo: {
    pt: 'Código',
    en: 'Code',
    es: 'Código',
    de: 'Code',
  },
  descricao: {
    pt: 'Adicione abaixo os códigos ERP referente a esse cliente.',
    en: 'Add the ERP codes below for this client.',
    es: 'Fügen Sie die ERP-Codes für diesen Kunden unten ein.',
    de: 'Fügen Sie unten die ERP-Codes für diesen Kunden hinzu.',
  },
  adicionar: {
    pt: 'Adicionar',
    en: 'Add',
    es: 'Agregar',
    de: 'Hinzufügen',
  },
};
